import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ColegioService from '../services/ColegioService';
import ParticularService from '../services/ParticularService';

// Componente de pantalla de carga
const LoadingScreen = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
    color: 'white',
    flexDirection: 'column',
    gap: '1rem'
  }}>
    <div style={{
      width: '60px',
      height: '60px',
      border: '4px solid rgba(255, 255, 255, 0.3)',
      borderTop: '4px solid white',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }}></div>
    <p style={{ fontSize: '1.1rem', fontWeight: '500' }}>
      Verificando autenticación...
    </p>
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);

// Componente para proteger rutas
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  const colegios = ColegioService.getColegios();
  const activeColegio = ColegioService.getActiveColegio();
  const particulares = ParticularService.getParticulares();
  const activeParticular = ParticularService.getActiveParticular();
  const roleName = (user?.roleName || user?.nombreRol || user?.role || '').toLowerCase();
  const isAdmin = roleName.includes('admin');
  const isParticularRole = roleName.includes('particular');
  const isAlumnoParticular = roleName.includes('alumnoparticular') || (roleName.includes('alumno') && isParticularRole);
  const needsColegioSelection = !isParticularRole && colegios && colegios.length > 1 && !activeColegio;
  const needsParticularSelection = isParticularRole && particulares && particulares.length > 1 && !activeParticular;


  // Mostrar pantalla de carga mientras se verifica la autenticación
  if (isLoading) {
    return <LoadingScreen />;
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isParticularRole && location.pathname === '/dashboard') {
    return <Navigate to={isAlumnoParticular ? '/particular/alumno-panel' : '/particular'} replace />;
  }

  if (!isAdmin && needsParticularSelection && location.pathname !== '/select-colegio') {
    return <Navigate to="/select-colegio" replace state={{ from: location }} />;
  }

  // Para admin usamos el flujo nuevo, no aplicar la lógica clásica de selección múltiple
  if (!isAdmin && needsColegioSelection && location.pathname !== '/select-colegio') {
    return <Navigate to="/select-colegio" replace state={{ from: location }} />;
  }

  // Si está autenticado, mostrar el contenido protegido
  return children;
};

export default ProtectedRoute;
